import { compose, withState, lifecycle, withHandlers } from 'recompose'
import toggle from 'components/common/hoc/toggle'
import ServiceDescription from './ServiceDescription'
import debounce from 'lodash/debounce'

const withInnerWidth = withState('innerWidth', 'setInnerWidth', 0)

const withHandleResize = withHandlers({
  handleResize: ({ setInnerWidth }) =>
    debounce(() => setInnerWidth(window.screen.width), 500)
})

const withToggleHandlers = withHandlers({
  toggleOnClick: ({ toggleHandlers: { onClick } = {}}) => e => {
    if (e.target && e.target.attributes['data-toggle-link']) {
      e.preventDefault()
      onClick(e)
    }
  }
})

const withLifecycle = lifecycle({
  componentDidMount() {
    const { handleResize, expanded, toggle } = this.props
    window.addEventListener('resize', handleResize)
    handleResize()

    if (expanded) {
      setTimeout(() => {
        toggle()
      }, 1500)
    }
  },
  componentWillUnmount() {
    const { handleResize } = this.props
    window.removeEventListener('resize', handleResize)
  }
})

export default compose(
  toggle,
  withInnerWidth,
  withHandleResize,
  withToggleHandlers,
  withLifecycle
)(ServiceDescription)
